import * as React from 'react';

function MoneyIcon(props) {
  return (
    <svg width={72} height={72} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M17.792 24.5c0-6.351 5.149-11.5 11.5-11.5s11.5 5.149 11.5 11.5S35.643 36 29.292 36s-11.5-5.149-11.5-11.5z'
        fill='url(#prefix__paint0_linear_898_19527)'
      />
      <g filter='url(#prefix__filter0_bi_898_19527)'>
        <path
          d='M36 27.375c0-6.351 5.149-11.5 11.5-11.5S59 21.024 59 27.375s-5.149 11.5-11.5 11.5S36 33.726 36 27.375z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M28.333 41.75c0-6.351 5.149-11.5 11.5-11.5s11.5 5.149 11.5 11.5-5.149 11.5-11.5 11.5-11.5-5.149-11.5-11.5z'
        fill='url(#prefix__paint1_linear_898_19527)'
      />
      <g filter='url(#prefix__filter1_bi_898_19527)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16 38.394a3 3 0 00-3 3v13.965a3 3 0 003 3h2.785a3 3 0 003-3v-.784c1.161.863 2.545 1.595 4.015 2.282 3.521 1.648 8.361 2.53 10.782 2.255 2.421-.275 14.529-8.569 15.409-9.942.88-1.372-1.38-1.89-2.26-1.89-.349 0-1.756.657-3.493 1.468-2.653 1.238-6.075 2.836-7.671 3.002-2.113.22-6.604-2.58-8.145-3.677 1.76 0 6.656-.267 7.4-.55.96-.364 1.366-2.47.743-2.47-2.501 0-5.352-.944-8.001-1.822-2.3-.762-4.448-1.473-6.084-1.473a6.28 6.28 0 00-2.695.612v-.976a3 3 0 00-3-3H16z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <linearGradient
          id='prefix__paint0_linear_898_19527'
          x1={17.792}
          y1={13}
          x2={37.848}
          y2={10.669}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_898_19527'
          x1={28.333}
          y1={30.25}
          x2={48.389}
          y2={27.919}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_898_19527'
          x={32}
          y={11.875}
          width={31}
          height={31}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_898_19527' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_898_19527' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_898_19527' />
        </filter>
        <filter
          id='prefix__filter1_bi_898_19527'
          x={9}
          y={34.394}
          width={47.191}
          height={28.767}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_898_19527' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_898_19527' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_898_19527' />
        </filter>
      </defs>
    </svg>
  );
}

export default MoneyIcon;
